// import { useState } from "react";
// import { Patch } from "../../Axios/AxiosFunctions";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { apiUrl } from "../../config/apiUrl";
// import PropTypes from 'prop-types';

// /**
//  * AssignContactDialog component allows assigning and removing users (by email) to a meeting.
//  * Provides search, confirmation, and assignment logic with UI feedback.
//  *
//  * @component
//  * @param {Object} props
//  * @param {Object} props.summary - The summary object containing meeting data.
//  * @param {Array} props.users - The list of all users.
//  * @param {Function} props.onClose - Handler to close the dialog.
//  * @param {Function} props.onAssign - Handler called after assignment with selected emails.
//  */
// const AssignContactDialog = ( { summary, users, onClose, onAssign,userId } ) =>
// {
//     const { access_token: accessToken } = useSelector( ( state ) => state?.authReducer );
//     const [ searchTerm, setSearchTerm ] = useState( "" );
//     const [ selectedEmails, setSelectedEmails ] = useState( summary.meetingData.emails || [] );
//     const [ isAssigning, setIsAssigning ] = useState( false );
//     const [ isRemoving, setIsRemoving ] = useState( false );
//     const [ confirmationEmail, setConfirmationEmail ] = useState( null );

//     const filteredUsers = users.filter( user =>
//         user.email.toLowerCase().includes( searchTerm.toLowerCase() ) ||
//         `${user.firstName} ${user.lastName}`.toLowerCase().includes( searchTerm.toLowerCase() )
//     );

//     /**
//      * Toggles selection of an email for assignment/removal.
//      * If already selected, triggers confirmation for removal.
//      *
//      * @param {string} email - The email to toggle.
//      */
//     const toggleEmailSelection = ( email ) =>
//     {
//         if ( selectedEmails.includes( email ) )
//         {
//             setConfirmationEmail( email );
//         } else
//         {
//             setSelectedEmails( prev => [ ...prev, email ] );
//         }
//     };

//     /**
//      * Handles confirmation and removal of an email from selectedEmails.
//      *
//      * @param {boolean} shouldRemove - Whether to remove the email.
//      * @async
//      * @returns {Promise<void>}
//      */
//     const handleConfirmRemove = async ( shouldRemove ) =>
//     {
//         if ( shouldRemove )
//         {
//             setIsRemoving( true );
//             try
//             {
//                 await new Promise( resolve => setTimeout( resolve, 300 ) );
//                 setSelectedEmails( prev => prev.filter( e => e !== confirmationEmail ) );
//             } finally
//             {
//                 setIsRemoving( false );
//             }
//         }
//         setConfirmationEmail( null );
//     };

//     /**
//      * Handles assigning selected emails to the meeting via API call.
//      * Provides UI feedback and calls onAssign prop.
//      *
//      * @async
//      * @returns {Promise<void>}
//      */
//     const handleAssign = async () =>
//     {
//         if ( selectedEmails.length === 0 )
//         {
//             toast.warning( "Please select at least one user." );
//             return;
//         }

//         setIsAssigning( true );
//         try
//         {
//             const route = `${apiUrl}/api/v1/zoom/add-meeting-emails`;
//             const body = {
//                 _id: summary.meetingData.id,
//                 emails: selectedEmails,
//                 userId:userId
//             };
//             // console.log( "body---", body );
//             // return;
//             const response = await Patch( route, body, accessToken, true, ( err ) =>
//             {
//                 toast.error( "Failed to assign contacts." );
//                 console.error( "Error assigning emails:", err );
//             } );

//             if ( response?.data?.success )
//             {
//                 toast.success( "Contacts assigned successfully!" );
//                 console.log( "selectedEmails---", selectedEmails );
//                 await onAssign( selectedEmails );
//             } else
//             {
//                 toast.error( `Assignment failed: ${response?.data?.message}` );
//             }
//         } catch ( error )
//         {
//             toast.error( "Something went wrong during assignment." );
//             console.error( "Assignment error:", error );
//         } finally
//         {
//             setIsAssigning( false );
//         }
//     };

//     return (
//         <div className="dialog-overlay">
//             <div className="assign-dialog">
//                 <div className="dialog-header">
//                     <h6>Assign Contacts for: {summary.title}</h6>
//                     <button
//                         className="close-btn"
//                         onClick={onClose}
//                         disabled={isAssigning || isRemoving}
//                     >
//                         ×
//                     </button>
//                 </div>

//                 <div className="dialog-body">
//                     <div className="search-bar">
//                         <input
//                             type="text"
//                             placeholder="Search users..."
//                             value={searchTerm}
//                             onChange={( e ) => setSearchTerm( e.target.value )}
//                             disabled={isAssigning || isRemoving}
//                         />
//                     </div>

//                     <div className="users-list">
//                         {filteredUsers.map( user => (
//                             <div key={user._id} className="user-item">
//                                 <input
//                                     type="checkbox"
//                                     id={`user-${user._id}`}
//                                     checked={selectedEmails.includes( user.email )}
//                                     onChange={() => toggleEmailSelection( user.email )}
//                                     disabled={isAssigning || isRemoving}
//                                 />
//                                 <label htmlFor={`user-${user._id}`}>
//                                     {user.firstName} {user.lastName} ({user.email})
//                                 </label>
//                             </div>
//                         ) )}
//                     </div>
//                 </div>

//                 <div className="dialog-footer">
//                     <button
//                         className="cancel-btn"
//                         onClick={onClose}
//                         disabled={isAssigning || isRemoving}
//                     >
//                         Cancel
//                     </button>
//                     <button
//                         className="assign-btn"
//                         onClick={handleAssign}
//                         disabled={isAssigning || isRemoving || selectedEmails.length === 0}
//                     >
//                         {isAssigning ? (
//                             <>
//                                 <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                 Assigning...
//                             </>
//                         ) : "Assign"}
//                     </button>
//                 </div>

//                 {confirmationEmail && (
//                     <div className="confirmation-overlay">
//                         <div className="confirmation-dialog">
//                             <p>Do you want to remove {confirmationEmail} from this meeting?</p>
//                             <div className="confirmation-buttons">
//                                 <button
//                                     onClick={() => handleConfirmRemove( true )}
//                                     disabled={isRemoving}
//                                 >
//                                     {isRemoving ? (
//                                         <>
//                                             <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                             Removing...
//                                         </>
//                                     ) : "Yes"}
//                                 </button>
//                                 <button
//                                     onClick={() => handleConfirmRemove( false )}
//                                     disabled={isRemoving}
//                                 >
//                                     No
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// AssignContactDialog.propTypes = {
//     summary: PropTypes.shape( {
//         meetingData: PropTypes.shape( {
//             id: PropTypes.any,
//             emails: PropTypes.arrayOf( PropTypes.string ),
//         } ),
//         title: PropTypes.string,
//     } ),
//     users: PropTypes.arrayOf( PropTypes.shape( {
//         _id: PropTypes.any,
//         email: PropTypes.string,
//         firstName: PropTypes.string,
//         lastName: PropTypes.string,
//     } ) ),
//     onClose: PropTypes.func,
//     onAssign: PropTypes.func,
// };

// export default AssignContactDialog;



import { useState } from "react";
import { Patch } from "../../Axios/AxiosFunctions";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { apiUrl } from "../../config/apiUrl";
import PropTypes from 'prop-types';

/**
 * AssignContactDialog component allows assigning and removing users (by email) to a meeting.
 * Provides search, confirmation, and assignment logic with UI feedback.
 *
 * @component
 * @param {Object} props
 * @param {Object} props.summary - The summary object containing meeting data.
 * @param {Array} props.users - The list of all users.
 * @param {Function} props.onClose - Handler to close the dialog.
 * @param {Function} props.onAssign - Handler called after assignment with selected emails.
 */
const AssignContactDialog = ( { summary, users, onClose, onAssign, userId } ) =>
{
    const { access_token: accessToken } = useSelector( ( state ) => state?.authReducer );
    const [ searchTerm, setSearchTerm ] = useState( "" );
    const [ selectedEmails, setSelectedEmails ] = useState( summary.meetingData.emails || [] );
    const [ isAssigning, setIsAssigning ] = useState( false );
    const [ isRemoving, setIsRemoving ] = useState( false );
    const [ confirmationEmail, setConfirmationEmail ] = useState( null );

    // Filter out users who are already in the meeting
    const filteredUsers = users.filter( user =>
        // Exclude users already in the meeting
        !summary.meetingData.emails?.includes( user.email ) &&
        !selectedEmails.includes(user.email) &&
        // Include users that match search term
        ( user.email.toLowerCase().includes( searchTerm.toLowerCase() ) ||
            `${user.firstName} ${user.lastName}`.toLowerCase().includes( searchTerm.toLowerCase() ) )
    );

    /**
     * Toggles selection of an email for assignment/removal.
     * If already selected, triggers confirmation for removal.
     *
     * @param {string} email - The email to toggle.
     */
    const toggleEmailSelection = ( email ) =>
    {
        if ( selectedEmails.includes( email ) )
        {
            setConfirmationEmail( email );
        } else
        {
            setSelectedEmails( prev => [ ...prev, email ] );
        }
    };

    /**
     * Handles confirmation and removal of an email from selectedEmails.
     *
     * @param {boolean} shouldRemove - Whether to remove the email.
     * @async
     * @returns {Promise<void>}
     */
    const handleConfirmRemove = async ( shouldRemove ) =>
    {
        if ( shouldRemove )
        {
            setIsRemoving( true );
            try
            {
                await new Promise( resolve => setTimeout( resolve, 300 ) );
                setSelectedEmails( prev => prev.filter( e => e !== confirmationEmail ) );
            } finally
            {
                setIsRemoving( false );
            }
        }
        setConfirmationEmail( null );
    };

    /**
     * Handles assigning selected emails to the meeting via API call.
     * Provides UI feedback and calls onAssign prop.
     *
     * @async
     * @returns {Promise<void>}
     */
    const handleAssign = async () =>
    {
        if ( selectedEmails.length === 0 )
        {
            toast.warning( "Please select at least one user." );
            return;
        }
        // console.log( "selectedEmails----", selectedEmails )
        // alert();
        // return;

        setIsAssigning( true );
        try
        {
            const route = `${apiUrl}/api/v1/zoom/add-meeting-emails`;
            const body = {
                _id: summary.meetingData.id,
                emails: selectedEmails,
                userId: userId
            };

            const response = await Patch( route, body, { headers: { Authorization: `Bearer ${ accessToken }` } }, null, true, ( err ) =>
            {
                toast.error( "Failed to assign contacts." );
                console.error( "Error assigning emails:", err );
            } );

            if ( response?.data?.success )
            {
                toast.success( "Contacts assigned successfully!" );
                await onAssign( selectedEmails );
            } else
            {
                toast.error( `Assignment failed: ${response?.data?.message}` );
            }
        } catch ( error )
        {
            toast.error( "Something went wrong during assignment." );
            console.error( "Assignment error:", error );
        } finally
        {
            setIsAssigning( false );
        }
    };

    console.log( "summary.meetingData.emails", summary.meetingData.emails );
    console.log( "users---", users );

    return (
        <div className="dialog-overlay">
            <div className="assign-dialog">
                <div className="dialog-header">
                    <h6>Assign Contacts for: {summary.title}</h6>
                    <button
                        className="close-btn"
                        onClick={onClose}
                        disabled={isAssigning || isRemoving}
                    >
                        ×
                    </button>
                </div>

                <div className="dialog-body">
                    <div className="search-bar">
                        <input
                            type="text"
                            placeholder="Search users..."
                            value={searchTerm}
                            onChange={( e ) => setSearchTerm( e.target.value )}
                            disabled={isAssigning || isRemoving}
                        />
                    </div>

                    {/* Show message if all users are already assigned */}
                    {filteredUsers.length === 0 && (
                        <div className="no-users-message">
                            <p>All available users are already assigned to this meeting.</p>
                        </div>
                    )}

                    <div className="users-list">
                        {filteredUsers.map( user => (
                            <div key={user._id} className="user-item">
                                <input
                                    type="checkbox"
                                    id={`user-${user._id}`}
                                    checked={selectedEmails.includes( user.email )}
                                    onChange={() => toggleEmailSelection( user.email )}
                                    disabled={isAssigning || isRemoving}
                                />
                                <label htmlFor={`user-${user._id}`}>
                                    {user.firstName} {user.lastName} ({user.email})
                                </label>
                            </div>
                        ) )}
                    </div>

                    {/* Show already assigned users section */}
                    {summary.meetingData.emails && summary.meetingData.emails.length > 0 && (
                        <div className="assigned-users-section">
                            <h6>Already Assigned to this Meeting:</h6>
                            <div className="assigned-users-list">
                                {/* {users
                                    .filter( user => summary.meetingData.emails.includes( user.email ) )
                                    .map( user => (
                                        <div key={user._id} className="user-item">
                                            <input
                                                type="checkbox"
                                                id={`user-${user._id}`}
                                                checked={selectedEmails.includes( user.email )}
                                                onChange={() => toggleEmailSelection( user.email )}
                                                disabled={isAssigning || isRemoving}
                                            />
                                            <label htmlFor={`user-${user._id}`}>
                                                {user.firstName} {user.lastName} ({user.email})
                                            </label>
                                            {user.firstName} {user.lastName} ({user.email})
                                        </div>
                                    ) )} */}
                                {selectedEmails.map( e => (
                                    <div key={e} className="user-item">
                                        <input
                                            type="checkbox"
                                            id={`user-${e}`}
                                            checked={selectedEmails.includes( e )}
                                            onChange={() => toggleEmailSelection( e )}
                                            disabled={isAssigning || isRemoving}
                                        />
                                        <label htmlFor={`user-${e}`}>
                                            {e}
                                        </label>
                                    </div>
                                ) )}
                            </div>
                        </div>
                    )}
                </div>

                <div className="dialog-footer">
                    <button
                        className="cancel-btn"
                        onClick={onClose}
                        disabled={isAssigning || isRemoving}
                    >
                        Cancel
                    </button>
                    <button
                        className="assign-btn"
                        onClick={handleAssign}
                        disabled={isAssigning || isRemoving || selectedEmails.length === 0}
                    >
                        {isAssigning ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Assigning...
                            </>
                        ) : "Assign"}
                    </button>
                </div>

                {confirmationEmail && (
                    <div className="confirmation-overlay">
                        <div className="confirmation-dialog">
                            <p>Do you want to remove {confirmationEmail} from this meeting?</p>
                            <div className="confirmation-buttons">
                                <button
                                    onClick={() => handleConfirmRemove( true )}
                                    disabled={isRemoving}
                                >
                                    {isRemoving ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Removing...
                                        </>
                                    ) : "Yes"}
                                </button>
                                <button
                                    onClick={() => handleConfirmRemove( false )}
                                    disabled={isRemoving}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

AssignContactDialog.propTypes = {
    summary: PropTypes.shape( {
        meetingData: PropTypes.shape( {
            id: PropTypes.any,
            emails: PropTypes.arrayOf( PropTypes.string ),
        } ),
        title: PropTypes.string,
    } ),
    users: PropTypes.arrayOf( PropTypes.shape( {
        _id: PropTypes.any,
        email: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
    } ) ),
    onClose: PropTypes.func,
    onAssign: PropTypes.func,
    userId: PropTypes.string,
};

export default AssignContactDialog;